import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { CharacterCount } from './components/CharacterCount';
import * as React from 'react';
import { EditorContent } from '@tiptap/react';
import { Box, Input } from '@chakra-ui/react';
import { SubmitErrorComponent } from './components/SubmitError';
import type { EditorPreset } from './presets';
import { MenuBar } from './presets';
import { useEditorContext, withEditorContext } from './editor_context';

const TiptapEditorComponent = (props: {
   editorid: string;
   preset: EditorPreset;
   useCharacterCount?: boolean;
}) => {
   const { editorid, useCharacterCount, preset } = props;
   const { editor, isFocused } = useEditorContext();
   const submitError = editor?.storage.submitError.error;

   return (
      <>
         <Box id={editorid} className="ProseMirror-menubar-wrapper">
            <MenuBar preset={preset} />
            <EditorContent editor={editor} />
         </Box>
         {isFocused() && useCharacterCount ? <CharacterCount /> : null}
         {submitError ? <SubmitErrorComponent error={submitError} /> : null}
      </>
   );
};

export const TiptapEditor = withEditorContext(TiptapEditorComponent);

initializeChakraComponent('TiptapEditor', TiptapEditor);
